import { render, staticRenderFns } from "./EventPerdatinAdd.vue?vue&type=template&id=3b01b426&scoped=true"
import script from "./EventPerdatinAdd.vue?vue&type=script&lang=js"
export * from "./EventPerdatinAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b01b426",
  null
  
)

export default component.exports